import React from "react"

const LocaleContext = React.createContext({language: "en", setLanguage: () => {}})
export default LocaleContext
